import "./self-preparation.scss";
type SelfPreparationProps = {};

const SelfPreparation = (props: SelfPreparationProps) => {
  return (
    <>
      <div className="self-preparation page">
        <div className="self-preparation__header page__header">
          <h1 className="self-preparation__header__title page__header__title">
            САМОПОДГОТОВКА
          </h1>
        </div>
        <div className="self-preparation__body">
          <div className="self-preparation__body__content">
            <p>
              Самоподготовката допринася за правилното и трайно усвояване на
              учебния материал и съдейства за формиране навици за самостоятелно
              учене с разбиране, стимулира любознателността и стремежа към
              знание, толерантно взаимодействие чрез усъвършенстване на уменията
              за общуване
            </p>
          </div>
        </div>
      </div>
      <p></p>
    </>
  );
};

export default SelfPreparation;
